import React from 'react';
import {Alert, Badge, Form, Icon, Input, Button, Select, DatePicker, Row, Col, Upload } from 'antd';
import get from 'lodash/get';
import { connect } from 'react-redux';

import { updateAuditLogsRequest, getSettingsSitesRequest} from "../../api/requests";
import {
  getAuditLogUpdatePermission
} from "../../reducers/user/selectors";

import classes from './AuditForm.css';
import { logout } from "../../reducers/user/actions";
import { withNamespaces } from 'react-i18next';

const { Option } = Select;

class AuditForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      requestResult: {},
      sites: [],
    };
  }

  async componentDidMount() {
    try {
      const { data } = await getSettingsSitesRequest();
      this.setState({ sites: data });
    } catch (e) { if (e.response.status === 401) { this.props.logout();  return; } console.log(e); }
  }

  handleSubmit = e => {
    e.preventDefault();

    this.props.form.validateFields(async (err, values) => {
      this.setState({ isSubmitted: true, requestResult: {} });

      if (!err) {
        this.setState({ isLoading: true });

        try {
          const audit = {...values};

          await updateAuditLogsRequest(this.props.id , audit);

          this.setState({ isLoading: false, requestResult: { type: 'success', message: this.props.i18n.t('Success') } });

          setTimeout(() => {
            this.props.onSubmit(this.props.id);
          }, 1000);
        } catch (e) {
          if (get(e, 'response.status') === 401) { this.props.logout();  return; }
          this.setState({ isLoading: false, requestResult: { type: 'error', message: get(e, 'response.data.message', this.props.i18n.t('Error')) } });

          if (get(e, 'response.data.errors')) {
            const errors = {};
            Object.keys(get(e, 'response.data.errors')).forEach(errorFieldKey => {
              errors[errorFieldKey] = {
                value: values[errorFieldKey],
                errors: get(e, `response.data.errors.${errorFieldKey}`).map(errorMessage => new Error(errorMessage))
              }
            });
            this.props.form.setFields(errors);
          }
        }
      }
    });
  };


  render() {
    const { isLoading, requestResult, sites } = this.state;
    const { getFieldDecorator, getFieldValue } = this.props.form;
    const { auditUpdatePermission, isNew } = this.props;

    const categoryVal = getFieldValue('category');

    const isEditable = auditUpdatePermission;

    return (
      <div className={classes.wrapper}>
        <Form onSubmit={this.handleSubmit}>
          <h4 className='headline-default'>
            {this.props.id ? (<span>{this.props.i18n.t('NamespaceAuditForm:Audit Log')}<Badge count={this.props.i18n.t('Edit')} style={{ backgroundColor: '#2968AE' }} /></span>) : isNew ? this.props.i18n.t('NamespaceAuditForm:Create audit') : ''}
          </h4>

          {this.props.subject && <div>
            <b>{this.props.i18n.t('Subject')}</b>
            <p>{get(this.props, 'subject.code')}</p>
          </div>}

          <b>{this.props.i18n.t('Message')}</b>
          <p>{this.props.message}</p>

          <Row gutter={12}>
            <Col>
              <label>
                <b>{this.props.i18n.t('Comments')}</b>
                <Form.Item>
                  {getFieldDecorator('comments', {
                    initialValue: get(this.props, 'comments'),
                  })(
                    <Input.TextArea disabled={!isEditable} />
                  )}
                </Form.Item>
              </label>
            </Col>
          </Row>

          {requestResult.type && (<Alert message={requestResult.message} type={requestResult.type} className={classes.submitResult} />)}

          <div className={classes.actionWrapper}>
            {isEditable && (<Form.Item>
              <Button type="primary" size="large" htmlType="submit" className={classes.submitButton}>
                {this.props.i18n.t('Save')}
                {isLoading && <Icon type="loading" />}
              </Button>&nbsp; &nbsp;
            </Form.Item>)}

            <Button type="default" size="large" htmlType="button" className={classes.submitButton} onClick={this.props.onCancel}>
              {this.props.i18n.t('Cancel')}
            </Button>
          </div>
        </Form>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  auditUpdatePermission: getAuditLogUpdatePermission(state)
});

const mapDispatchToProps = { logout };

export default Form.create({ name: 'user' })(connect(mapStateToProps, mapDispatchToProps)(withNamespaces()(AuditForm)));



// WEBPACK FOOTER //
// ./src/components/AuditForm/AuditForm.js